export default __webpack_public_path__ + "static/media/about-us-logo.b68bec92.svg";